import LocalizedStrings from "react-localization";

export const poolMetadataStrings = new LocalizedStrings({
  en: {
    metadataTitle: "Metadata",
    providerId: "Provider ID",
    id: "ID",
    hash: "Hash",
    type: "Type",
    date: "Date",
    advertiser: "Advertiser",
    campaign: "Campaign",
    link: "Link",
    title: "Title",
  },
  fr: {
    metadataTitle: "Metadata",
    providerId: "Provider ID",
    id: "ID",
    hash: "Hash",
    type: "Type",
    date: "Date",
    advertiser: "Advertiser",
    campaign: "Campaign",
    link: "Link",
    title: "Title",
  },
});
